import { createRoutine } from 'redux-saga-routines';

export const completeLeverIntegrationRoutine = createRoutine('COMPLETE_LEVER_INTEGRATION');
